import type { ComplianceDocType, ComplianceRowStatus } from '../../services/vendorService';

/** V2-078: the Vendor Compliance report, in the Procurement report category. */
export const VENDOR_COMPLIANCE_SECTION = 'procurement-vendor-compliance';

/** Who sees the report and the Home tiles (Q9): the Vendor Compliance widget or vendor view. */
export const VENDOR_COMPLIANCE_PERMISSIONS = ['widget:insurance_expiries', 'heMaster:vendor_view'] as const;

export const COMPLIANCE_STATUS_LABELS: Record<ComplianceRowStatus, string> = {
  OVERDUE: 'Overdue',
  DUE_SOON: 'Due in 30 days',
  MISSING: 'Missing',
  CURRENT: 'Current',
};

export const COMPLIANCE_DOC_TYPE_LABELS: Record<ComplianceDocType, string> = {
  WCB: 'WCB Clearance',
  LIABILITY_INSURANCE: 'Liability Insurance',
  VEHICLE_INSURANCE: 'Vehicle Insurance',
};

/** Reports page opened on the Vendor Compliance report, filtered to one status (a Home tile). */
export function vendorComplianceReportPath(status?: ComplianceRowStatus): string {
  const q = new URLSearchParams({ report: VENDOR_COMPLIANCE_SECTION });
  if (status) q.set('status', status);
  return `/reports?${q.toString()}`;
}
